export type SortOrder = 'name-asc' | 'name-desc';

type T = { name?: string | null };
export const sort = (sortOrder: SortOrder) => {
  return (a: T, b: T) => {
    const comparison = (a.name || '')
      .toLowerCase()
      .localeCompare((b.name || '').toLowerCase());
    return sortOrder === 'name-asc' ? comparison : -comparison;
  };
};
